import { InputText } from 'primereact/inputtext';
import React from 'react';

interface SetpointTableTitlesEditorProps {
    currentConfig: any;
    handleTableTitlesChange: (id: string, value: string) => void;
}

const SetpointTableTitlesEditor = ({ currentConfig, handleTableTitlesChange }: SetpointTableTitlesEditorProps) => {
    return (
        <>
            <div className='col-3 gap-2 flex flex-column justify-content-center align-items-center'>
                <label htmlFor='datasetTitle'>Dataset Title</label>
                <InputText
                    id='datasetTitle'
                    type='text'
                    value={currentConfig.tableTitles?.datasetTitle}
                    onChange={(e) => handleTableTitlesChange(e.target.id, e.target.value)}
                />
            </div>
            <div className='col-3 gap-2 flex flex-column justify-content-center align-items-center'>
                <label htmlFor='datasetValueTitle'>Dataset Value Title</label>
                <InputText
                    id='datasetValueTitle'
                    type='text'
                    value={currentConfig.tableTitles?.datasetValueTitle}
                    onChange={(e) => handleTableTitlesChange(e.target.id, e.target.value)}
                />
            </div>
            <div className='col-3 gap-2 flex flex-column justify-content-center align-items-center'>
                <label htmlFor='setpointValueTitle'>Setpoint Value Title</label>
                <InputText
                    id='setpointValueTitle'
                    type='text'
                    value={currentConfig.tableTitles?.setpointValueTitle}
                    onChange={(e) => handleTableTitlesChange(e.target.id, e.target.value)}
                />
            </div>
            <div className='col-3 gap-2 flex flex-column justify-content-center align-items-center'>
                <label htmlFor='tagTitle'>Tag Title</label>
                <InputText
                    id='tagTitle'
                    type='text'
                    value={currentConfig.tableTitles?.tagTitle}
                    onChange={(e) => handleTableTitlesChange(e.target.id, e.target.value)}
                />
            </div>
        </>
    );
};

export default SetpointTableTitlesEditor;
